import { createAction } from '@reduxjs/toolkit';

export const ERROR_ACTION = createAction<string>('errorAction');
